import React, { Component } from "react";
import { Modal, Form, Row, Col, Button } from "antd";
import "./Form.css";
import InputForm from "./InputForm";
import ProdutoFrame from './ProdutoFrame';
import GrupoProdutoFrame from './GrupoProdutoFrame';
import MarcaFrame from './MarcaFrame';

const { Item: ItemForm } = Form;

export const OPCOES_COMBO_SITUACAO = [
  {
    key: 'X',
    label: 'Todos as Situações'
  },
  {
    key: '1',
    label: 'ATIVO'
  },
  {
    key: '0',
    label: 'INATIVO'
  },
]

export default class ProdutoFiltroForm extends Component {
  state = {
    registroFiltros: {
      tipoTela: '',
      buscaProduto: { key: '0' },
      buscaMarca: { key: '0' },
      buscaGrupo: { key: '0' },
      buscaSituacao: { key: '0' },
      buscaEstoqueBaixo: 0,
    }
  };


  componentDidUpdate(propsAnterior) {
    if (this.props.filtros !== propsAnterior.filtros) {
      this.setState({
        registroFiltros: this.props.filtros,
      }, () => {

      });
    }
  }


  onOK = () => {
    this.props.onFiltrarClick(this.state.registroFiltros);
  };

  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registroFiltros } = this.state;
    registroFiltros[id] = value;
    this.setState({
      [id]: value
    });
  };


  onChangeProduto = event => {
    const { registroFiltros } = this.state;
    registroFiltros['buscaProduto'] = event.buscaProduto;
    this.setState(event);
  }

  onChangeGrupoProduto = event => {
    const { registroFiltros } = this.state;
    registroFiltros['buscaGrupo'] = event.buscaGrupo;
    this.setState(event);
  }

  onChangeMarcaProduto = event => {
    const { registroFiltros } = this.state;
    registroFiltros['buscaMarca'] = event.buscaMarca;
    this.setState(event);
  }




  render() {
    const { onCancelarFiltroClick, visivel } = this.props;
    const { tipoTela, buscaProduto, buscaMarca, buscaGrupo, buscaSituacao,
      buscaEstoqueBaixo
    } = this.state.registroFiltros;

    // console.log('ProdutoFiltroForm.this.state: ', this.state);

    return (
      <Modal
        title={"Filtro"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarFiltroClick}
        footer={null}
        width={"60%"}
        style={{ top: 10 }}
      >

        <Row>
          <Col xs={24} sm={12} style={{ paddingRight: 20 }}>
            <ProdutoFrame
              label="Produto"
              id="buscaProduto"
              value={buscaProduto}
              width={"100%"}
              onChange={this.onChangeProduto}
              controlaEstoque="1"
              descricaoPrimeiroItem="Todas os Produtos"
            />
          </Col>

          <Col xs={24} sm={12}>
            <span>Situação</span>
            <InputForm
              type="select"
              id="buscaSituacao"
              ref="buscaSituacao"
              value={buscaSituacao}
              placeholder="Selecione"
              onChange={this.onChange}
              data={OPCOES_COMBO_SITUACAO}
              validator={value => Boolean(value)}
              style={{ width: "100%" }}
            />
          </Col>
          <Col xs={24} sm={12} style={{ marginTop: -20, paddingRight: 20 }}>
            <GrupoProdutoFrame
              label="Grupo"
              id="buscaGrupo"
              value={buscaGrupo}
              width={"100%"}
              onChange={this.onChangeGrupoProduto}
              descricaoPrimeiroItem="Todas os Grupos"
            />
          </Col>
          <Col xs={24} sm={12} style={{ marginTop: -20 }}>
            <MarcaFrame
              label="Marca"
              id="buscaMarca"
              value={buscaMarca}
              width={"100%"}
              onChange={this.onChangeMarcaProduto}
              descricaoPrimeiroItem="Todas as Marcas"
            />
          </Col>
          <Col xs={24} sm={4} style={{ marginTop: -40 }} className="campoCheckBox">
            <InputForm
              type="checkbox"
              id="buscaEstoqueBaixo"
              ref="buscaEstoqueBaixo"
              onChange={this.onChange}
              value={buscaEstoqueBaixo}
            >
              Estoque Baixo
            </InputForm>
          </Col>
        </Row>

        <div>
          <ItemForm>
            <Row>
              <Col xs={24}>
                <Button
                  type="primary"
                  htmlType="button"
                  onClick={this.onOK}
                  className="btn-salvar"
                >
                  Filtrar
                </Button>

                <Button
                  htmlType="button"
                  onClick={onCancelarFiltroClick}
                  className="btn-fechar"
                >
                  Fechar
                </Button>
              </Col>
            </Row>
          </ItemForm>
        </div>


      </Modal >



    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ProdutoFiltroForm.js